angular.module('gym.bulkImports').directive('bulkImportUpload', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulkImports/show/bulkImportUpload.html.slim'),
    scope: {
      bulkImport: '=',
      next: '&',
      cancel: '&',
      selectFile: '&'
    },
    controller: ["$scope", function($scope) {
      return $scope.footerVisible = function() {
        var ref;
        return (ref = $scope.bulkImport.status) === 'file_processing' || ref === 'file_invalid' || ref === 'cancelled' || ref === 'ready_for_review';
      };
    }]
  };
});
